
import { GenericEntityMetadata, PropertyMetadata } from '@scisys-uim/uim-common';


export class UserAuditEventMetadataBase extends GenericEntityMetadata {
  constructor() {
    super('UserAuditEvent', {
      eventDate: <PropertyMetadata> {
        name: 'eventDate',
        type: 'Date',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      username: <PropertyMetadata> {
        name: 'username',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      }
    });
  }
  toKeyObject(item: any): any {
      return null;
  }
}



